import { useCallback } from "react";
import type { SendEmailFormData } from "@/components/shared/formElements/SendEmailForm";
import { toSendEmailTaskParameters } from "@/features/email/utils/send-email-task-parameters";
import {
  USER_TASK_ACTIONS,
  USER_TASK_ENTITY,
} from "@/features/tasks/constants";
import { useCreateTask } from "@/features/tasks/hooks";

export function useUserTaskSubmit() {
  const { createTaskAsync, isPending } = useCreateTask();

  const submitSendEmail = useCallback(
    async (userIds: number[], data: SendEmailFormData) => {
      await createTaskAsync({
        entityName: USER_TASK_ENTITY,
        actionName: USER_TASK_ACTIONS.sendEmail,
        selectedIds: userIds,
        executionParameters: toSendEmailTaskParameters(data),
        files: data.attachments,
      });
    },
    [createTaskAsync],
  );

  const submitSendNotification = useCallback(
    async (userIds: number[], body: string) => {
      await createTaskAsync({
        entityName: USER_TASK_ENTITY,
        actionName: USER_TASK_ACTIONS.sendNotification,
        selectedIds: userIds,
        executionParameters: {
          Body: body,
        },
      });
    },
    [createTaskAsync],
  );

  const submitDeactivate = useCallback(
    async (userIds: number[]) => {
      await createTaskAsync({
        entityName: USER_TASK_ENTITY,
        actionName: USER_TASK_ACTIONS.bulkDeactivate,
        selectedIds: userIds,
      });
    },
    [createTaskAsync],
  );

  return {
    submitSendEmail,
    submitSendNotification,
    submitDeactivate,
    isPending,
  };
}
